import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select } from 'react-bootstrap';
import { oneKlicks } from '../../../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../../../SDK/OneKlicksFileSDK';
import ImageShow from '../../../../Uitiles/ImageShow';
import { getuserdata } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { debugLog } from '../../../../utils/debug';

const EditAiService = ({ openEdit, setOpenEdit, getAiServices, selectedService }) => {   
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        pageLink: '',
        image: null,
        imagePreview: null
    });
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedService) {
            setFormData({
                name: selectedService.name || '',
                description: selectedService.description || '',
                pageLink: selectedService.pageLink || '',
                image: null,
                imagePreview: selectedService.image || null
            });
        }
    }, [selectedService]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFile(file);
            setFormData(prev => ({
                ...prev,
                image: file,
                imagePreview: URL.createObjectURL(file)
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let imageUrl = selectedService.image; // Keep existing image by default

            // Upload new image if provided
            if (file) {
                const uploadResponse = await OneKlicksFileSDK.uploadFile('ai_services', 'public', file);
                imageUrl = uploadResponse.file.root + '/' + uploadResponse.file.fileName;
            }

            // Prepare updated service data
            const updatedService = {
                ...selectedService,
                name: formData.name,
                description: formData.description,
                pageLink: formData.pageLink,
                image: imageUrl
            };

            // Get current services and update the specific one
            const tableSchema = '';
            const tableName = 'front_end_sessions';
            const conditions = {
                kaey: 'ai_services',
                status: 'active'
            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];
            
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            
            if (response.data && response.data.length > 0) {
                const parsedData = JSON.parse(response.data[0].data);
                const updatedServices = parsedData.map(service => 
                    service.id === selectedService.id ? updatedService : service
                );

                const data = {
                    kaey: "ai_services",
                    status: 'active',
                    data: JSON.stringify(updatedServices)
                };

                const updateResult = await oneKlicks.update(tableSchema, tableName, data, conditions);
                
                if (updateResult.success) {
                    toast.success('AI Service updated successfully');
                    setFormData({
                        name: '',
                        description: '',
                        pageLink: '',
                        image: null,
                        imagePreview: null
                    });
                    setOpenEdit(false);
                    getAiServices();
                } else {
                    toast.error('Failed to update AI Service');
                }
            }
        } catch (error) {
            debugLog('Error updating AI service:', error);
            toast.error('An error occurred while updating the AI service');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setFormData({
            name: '',
            description: '',
            pageLink: '',
            image: null,
            imagePreview: null
        });
        setFile(null);
        setOpenEdit(false);
    };

    return (
        <Modal show={openEdit} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit AI Service</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Service Name *</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="Enter service name"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description *</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder="Enter service description"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Page Link *</Form.Label>
                        <Form.Control
                            type="text"
                            name="pageLink"
                            value={formData.pageLink}
                            onChange={handleInputChange}
                            placeholder="Enter page URL"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Service Image</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                        {formData.imagePreview && (
                            <div className="mt-2">
                                <img 
                                    src={formData.imagePreview} 
                                    alt="Preview" 
                                    style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
                                />
                            </div>
                        )}
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-2" style={{ gap: 10 }}>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? 'Updating...' : 'Update Service'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditAiService;
